export const LOADER_DEPARTAMENTUSER             =    'LOADER_DEPARTAMENTUSER';
export const GET_DEPARTAMENTUSER                =    'GET_DEPARTAMENTUSER';
export const DEPARTAMENTUSER_FAIL               =    'DEPARTAMENTUSER_FAIL';
export const SAVE_LOADER_DEPARTAMENTUSER        =    'SAVE_LOADER_DEPARTAMENTUSER';
export const FORM_DEPARTAMENTUSER_FAIL          =    'FORM_DEPARTAMENTUSER_FAIL';

